import { render, staticRenderFns } from "./NavTypeDetail.vue?vue&type=template&id=549f9310&scoped=true"
import script from "./NavTypeDetail.vue?vue&type=script&lang=js"
export * from "./NavTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549f9310",
  null
  
)

export default component.exports